import api from './api';

// Загрузка изображений
export const uploadHomeworkImage = async (file) => {
  const formData = new FormData();
  formData.append('file', file);
  
  const result = await api.post('/upload/homework-image', formData, {
    headers: { 'Content-Type': 'multipart/form-data' }
  });
  
  return result;
};

// Загрузка любых файлов (PDF, DOC, ZIP и т.д.)
export const uploadHomeworkFile = async (file) => {
  const formData = new FormData();
  formData.append('file', file);
  
  const result = await api.post('/upload/homework-file', formData, {
    headers: { 'Content-Type': 'multipart/form-data' }
  });
  
  return result;
};

// Загрузка изображения для решения
export const uploadSolutionImage = async (file) => {
  const formData = new FormData();
  formData.append('file', file);
  
  const result = await api.post('/upload/solution-image', formData, {
    headers: { 'Content-Type': 'multipart/form-data' }
  });
  
  return result;
};

// Удаление файла
export const deleteHomeworkFile = async (filename) => {
  const result = await api.delete(`/upload/homework-file/${filename}`);
  return result;
};

export const deleteHomeworkImage = async (filename) => {
  const result = await api.delete(`/upload/homework-image/${filename}`);
  return result;
};

export const deleteSolutionImage = async (filename) => {
  const result = await api.delete(`/upload/solution-image/${filename}`);
  return result;
};